import { useElementShown } from '@hh.ru/analytics-js';
import assessmentSelectSkillButtonClick from '@hh.ru/analytics-js-events/build/career_platform/assessment_landing/assessment_select_skill_button_click';
import assessmentSelectSkillElementShown from '@hh.ru/analytics-js-events/build/career_platform/assessment_landing/assessment_select_skill_element_shown';
import { translation, TranslatedComponent } from '@hh.ru/front-static-app';
import { Button, GridLayout } from '@hh.ru/magritte-ui';

import ThemeContainer, { ThemeContainerBackground, ThemeContainerVariant } from 'src/components/ThemeContainer';
import { ASSESSMENT_SKILLS_CATALOG_LINK } from 'src/modules/externalLinks';

import styles from './styles.less';

const TrlKeys = {
    title: 'career-platform.page-cert-landing.section.banner.title',
    description: 'career-platform.page-cert-landing.section.banner.description',
    button: 'career-platform.page-cert-landing.section.banner.button',
};

const SectionBanner: TranslatedComponent = ({ trls }) => {
    const ref = useElementShown(assessmentSelectSkillElementShown);

    const handleClick = () => assessmentSelectSkillButtonClick();

    return (
        <ThemeContainer variant={ThemeContainerVariant.Night} background={ThemeContainerBackground.Transparent}>
            <section className={styles.container}>
                <GridLayout>
                    <div className={styles.content} ref={ref}>
                        <div className={styles.textContent}>
                            <h3 className={styles.title}>{trls[TrlKeys.title]}</h3>
                            <p className={styles.description}>{trls[TrlKeys.description]}</p>
                        </div>
                        <div className={styles.button}>
                            <Button
                                mode="primary"
                                style="accent"
                                size="large"
                                stretched
                                Element="a"
                                href={ASSESSMENT_SKILLS_CATALOG_LINK}
                                target="_blank"
                                rel="noreferrer noopener nofollow"
                                onClick={handleClick}
                            >
                                {trls[TrlKeys.button]}
                            </Button>
                        </div>
                    </div>
                </GridLayout>
            </section>
        </ThemeContainer>
    );
};

export default translation(SectionBanner);
